<template>
  <div>
    <tabelas-header
      :titulo="nomeDoPlano"
      texto1="Tabela de procedimentos passíveis da cobrança de coparticipação"
      texto2="Tabela de Referência - Padrão"
      :hasShowTable="isTable"
      :hasShowError="isError"
      :isLoading="isShowSkeleton"
    />
    <div class="buttons">
      <div class="pergunta-frequentes" :style="{ visibility: isShowTabela ? 'visible' : 'hidden' }">
        <a href="javascript:void(0)" @click.prevent="scrollToFaq" class="titulo-link-ancora" >
        <div class="container card-header-title-coparticipacao">
          <img src="../assets/images/help.svg"></img>&nbsp;&nbsp;Perguntas
          frequentes sobre coparticipação
        </div>
      </a></div>
      
<div>
<div class="outro-plano" @click="voltar"><img src="../assets/images/logout.svg"></img>Consultar outro plano</div>
</div>
      
    </div>
    <div class="card-pesquisa" v-if="isTable">
      <div class="card-container pesquisa-item">
        <pesquisa
          placeHolder="Digite o código ou a descrição do item desejado"
          v-model="filtro"
          :click="filtrarTabela"
        />
      </div>
    </div>

    <div class="card-tabelas">
      <div class="mensagem" v-if="isShowMessage">Nenhum item encontrado.</div>
      <b-skeleton-table
        class="table-skeleton"
        :columns="4"
        v-if="isShowSkeleton"
      >
      </b-skeleton-table>
      <b-skeleton
        v-if="isShowSkeleton"
        class="block-skeleton"
        width="100%"
      ></b-skeleton>
      <b-skeleton
        v-if="isShowSkeleton"
        class="block-skeleton"
        width="100%"
      ></b-skeleton>
      <b-skeleton
        v-if="isShowSkeleton"
        class="block-skeleton"
        width="100%"
      ></b-skeleton>
      <b-skeleton
        v-if="isShowSkeleton"
        class="block-skeleton"
        width="100%"
      ></b-skeleton>
      <b-table
        id="tabelaCoparticipacao"
        striped
        hover
        stacked="md"
        :fields="fields"
        :items="filtrarTabela"
        :per-page="perPage"
        :current-page="currentPage"
        :skeleton-rows="true"
        fixed
        v-if="isShowTabela"
        class="table-responsive"
      >
      </b-table>
      <b-pagination
        v-if="this.rows > this.perPage"
        v-model="currentPage"
        class="custom-pagination"
        :per-page="perPage"
        :total-rows="rows"
        align="center"
        prev-text="Anterior"
        next-text="Próximo"
        limit="5"
        hide-ellipsis
        hide-goto-end-buttons
      >
      </b-pagination>
    </div>
    <faq-coparticipacao :is-show-button="isShowTabela" />
  </div>
</template>

<script>
import Pesquisa from "../components/pesquisa/Pesquisa";
import Header from "../components/header/Header.vue";
import { API_URL } from "../http/base-urls";
import axios from "../http/index.js";
import Faq from "../components/faq/Faq";
import provedor from "../http/provedor.js";

export default {
  components: {
    Pesquisa,
    "tabelas-header": Header,
    "faq-coparticipacao": Faq,
  },
  data() {
    return {
      filtro: "",
      rows: 0,
      perPage: 100,
      currentPage: 1,
      isShowTabela: false,
      isShowMessage: false,
      isShowSkeleton: true,
      isShowPagination: true,
      nomeDoPlano: "",
      isUFSC: false,
      itens: [],
      fields: [
        {
          label: "Código",
          key: "CodItem",
          thStyle: { width: "10%" },
        },
        {
          label: "Procedimento",
          key: "Tabela",
          thStyle: { width: "20%" },
        },
        {
          label: "Descrição",
          key: "DescItem",
          thStyle: { width: "55%" },
        },
        {
          label: "Valor Total (R$)",
          key: "ValorItem",
          thStyle: { width: "15%" },
        },
      ],
      isError: false,
      isTable: false,
    };
  },
  mounted() {
    const dadoSalvo = localStorage.getItem("Carteirinha");

    if (dadoSalvo) {
      const numeroFormatado = JSON.parse(dadoSalvo);
      this.carteirinha = numeroFormatado.replace(/\D/g, "");
    }

    this.plano = JSON.parse(localStorage.getItem("Plano"));
    this.nomeDoPlano = (this.plano && this.plano.nome) ? this.plano.nome : "";
    this.isUFSC = this.plano.tabela == "UFSC";

    provedor.dispatch("autenticar").then(() => {
      const token = provedor.state.token;
      var config = {
        method: "get",
        url: `${API_URL}customer/ObterTabelaCopart?tabela=${this.plano}&carteirinha=${this.carteirinha}`,
        headers: { Authorization: `Bearer ${token}` },
      };
      
      axios(config)
        .then((response) => {
          if (response.status === 200) {
            this.nomeDoPlano = this.formatarNomePlano(response.data[0].Tabela);
            this.isTable = true;
            this.itens = response.data;
            this.rows = this.itens.length;
            this.isShowTabela = true;
            this.isShowSkeleton = false;
          } else if (response.status === 204) {
            this.isShowTabela = false;
            this.isShowSkeleton = false;
          }

          this.isShowMessage = true;
        })
        .catch((error) => {
          this.isError = true;
          this.isShowMessage = false;
          this.isShowSkeleton = false;
          this.isShowTabela = false;

          console.log(error);
        });
    }).catch((error) => {
      console.log(error);
      this.isError = true;
      this.isShowSkeleton = false;
    });
  },
  computed: {
    filtrarTabela() {
      if (this.isShowSkeleton) return;

      let itensFiltrado = this.itens;

      if (this.filtro) {
        const filtroTratado = this.filtro
          .trim()
          .normalize("NFD")
          .replace(/[\u0300-\u036f]/g, "")
          .replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

        let exp = new RegExp(filtroTratado, "i");

        itensFiltrado = this.itens.filter((tabela) => {
          const desc = String(tabela.DescItem || "")
            .normalize("NFD")
            .replace(/[\u0300-\u036f]/g, "");
          const cod = String(tabela.CodItem || "")
            .normalize("NFD")
            .replace(/[\u0300-\u036f]/g, "");
          return exp.test(desc) || exp.test(cod);
        });

        this.currentPage = 1;
      }

      this.rows = itensFiltrado.length;
      this.isShowMessage =
        itensFiltrado.length < 1 &&
        (!this.isShowSkeleton || !this.isShowTabela);
      this.isShowTabela = !this.isShowMessage;

      return itensFiltrado;
    },
  },
  methods: {
    scrollToFaq() {
      const element = document.getElementById("ancora-faq");
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    },
    voltar() {
      this.$router.push({ name: "PesquisaTabelaCoparticipacao", query: { t: Date.now() } });
    },
    formatarNomePlano(texto) {
      if (!texto) return "";

      const textoUpper = texto.toString().trim().toUpperCase();

      if (textoUpper.includes("LIGHT")) {
        return "Unimed Light";
      }

      if (textoUpper.includes("UNIFLEX") || textoUpper.includes("PERSONAL")) {
        return "Uniflex e Personal";
      }

      return textoUpper.replace(/[-/]/g, " ").trim();
    },
  },
};
</script>

<style scoped>
html {
  scroll-behavior: smooth;
}

a {
  text-decoration: none;
}

a,
a:active,
a:hover,
a:visited {
  color: #439763;
  font-weight: bold;

}

.outro-plano{
  color: var(--color-brand-primary);
font-size: 14px;
font-style: normal;
font-weight: 600;
line-height: 20px; 
letter-spacing: 0.1px;
cursor: pointer;
}

.buttons {
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: space-between;
  width: 918px;
  margin: auto;
}

.card-header-title-coparticipacao {
  font-size: 14px;
  border: 1px var(--color-brand-primary) solid;
  padding: 9px 0 9px 0;
  border-radius: 5px;
  display: flex;
  align-items: center;
}

:target {
  scroll-margin-top: 0.12em;
}

.card-pesquisa {
  font-family: UnimedSans-Regular;
  display: flex;
  height: 100px;
  padding: 0 5%;
  background-color: var(--color-brand-primary);
}

.pesquisa-item {
  width: 100%;
}

.card-tabelas {
  margin: auto;
  padding-top: 20px;
}

.card-aviso-ufsc {
  margin: auto;
  padding-top: 10px;
}

.block-skeleton {
  height: 120px;
}

.table-skeleton /deep/ th {
  height: 36px;
  background-color: var(--color-brand-primary);
}

.table-skeleton /deep/ th:first-child {
  width: 10%;
}

.table-skeleton /deep/ th:nth-child(2) {
  width: 20%;
}

.table-skeleton /deep/ th:nth-child(3) {
  width: 55%;
}

.table-skeleton /deep/ th:nth-child(4) {
  width: 15%;
}

.table-skeleton /deep/ td div {
  width: 100%;
}

.table-skeleton /deep/ th .b-skeleton-text,
td .b-skeleton-text {
  height: 36px;
}

.mensagem {
  font-size: 24px;
  text-align: center;
  padding-bottom: 40px;
}

#tabelaCoparticipacao /deep/ thead {
  background-color: var(--color-brand-primary);
  border: none;
  color: #FFF;
  font-family: "Trebuchet MS";
  font-size: 14px;
  font-style: normal;
  line-height: 24px; 
}

/deep/ .table {
  font-size: 13px;
}

/deep/ .table > :not(:first-child) {
  border: none;
}

/deep/ .table tbody tr td {
  font-family: "Trebuchet MS";
  border: none;
  color:var(--text-secondary);
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px;
}

.custom-pagination /deep/ .page-item.active .page-link {
  color: var(--color-brand-primary);
  border-color: var(--border-subtle);
  background-color: #fff;
  font-weight: bold;
}

.custom-pagination /deep/ li.page-item.disabled span.page-link {
  color: var(--color-brand-primary);
}

.custom-pagination /deep/ .page-item .page-link {
  color: var(--color-brand-primary);
}

@media (min-width: 0) {
  .buttons {
    flex-direction: column;
  }

  .table-skeleton {
    display: none;
  }

  .block-skeleton {
    display: block;
  }
}

@media (min-width: 768px) {
  .buttons {
    flex-direction: row;
  }
}

@media (min-width: 780px) {
  .card-tabelas {
    padding: 10px 5%;
  }

  .table-skeleton {
    display: inline-table;
  }

  .block-skeleton {
    display: none;
  }
}

@media (min-width: 992px) {
  .card-tabelas {
    padding: 10px 0;
    width: 920px;
  }
  .card-aviso-ufsc {
    padding: 10px 0;
    width: 920px;
  }
}

@media only screen and (min-device-width: 500px) and (max-device-width: 1840px) {
  .card-header-title-coparticipacao {
    justify-content: center;
    text-align: center;
    width: 500px;
    margin-left: auto;
    margin-right: auto;
    margin-top: 2%;
    margin-bottom: 2%;
  }
}

@media only screen and (min-device-width: 281px) and (max-device-width: 500px) {
  .icone-interrogacao {
    margin: 4% 0 0 5%;
    padding: 1%;
  }

  .card-header-title-coparticipacao {
    justify-content: center;
    text-align: center;
    width: 350px;
    margin-left: auto;
    margin-right: auto;
    margin-top: 2%;
    margin-bottom: 2%;
  }
}
@media only screen and (max-device-width: 280px) {
  .icone-interrogacao {
    margin: 4% 0 0 5%;
    padding: 1%;
  }
  .card-header-title-coparticipacao {
    display: flex;
    justify-content: center;
    text-align: center;
    width: 275px;
    margin-left: auto;
    margin-right: auto;
    margin-top: 2%;
    margin-bottom: 2%;
  }
}

@media (min-width: 1280px) {
  .icone-interrogacao {
    margin: 4% 0 0 5%;
  }
}
@media only screen and (min-device-width: 1103px) and (max-device-width: 3400px) {
  .icone-interrogacao {
    margin: 0 0 0 5%;
    padding: 1%;
  }

  .card-header-title-coparticipacao {
    justify-content: center;
    text-align: center;
    width: 25em;
    margin-left: auto;
    margin-right: auto;
    margin-top: 2%;
    margin-bottom: 2%;
  }
}
</style>
